export default function (key, data) {
  let message = window.__cscMessages__[key] || key;

  if (data && window.__cscMessages__[key]) {
    Object.keys(data).forEach((prop) => {
      if ({}.hasOwnProperty.call(data, prop)) {
        message = message.replace(new RegExp(`%{0,1}{${prop}}`, 'g'), data[prop] || '');
      }
    });
  }

  return message;
}



// WEBPACK FOOTER //
// ./src/utils/getTranslation.js